export default {
  placeholder: 'Select a color',
  color: {
    custom: 'Custom',
  },
  family: {
    black: 'Black',
    gray: 'Grey',
    slate: 'Bluegrey',
    red: 'Red',
    orange: 'Orange',
    yellow: 'Yellow',
    green: 'Green',
    teal: 'Teal',
    cyan: 'Cyan',
    blue: 'Blue',
    indigo: 'Indigo',
    purple: 'Purple',
    pink: 'Pink',
  },
};
